import React from 'react';
import { SubtitleSignatureHeader } from './style';
import Box from '@material-ui/core/Box';
import Typography from '@material-ui/core/Typography';
import Button from '@material-ui/core/Button';

interface SignatureHeaderProps {
  onClick?: () => void;
}

const SignatureHeader = ({ onClick }: SignatureHeaderProps) => {
  return (
    <Box display="flex" justifyContent="space-between">
      <Box>
        <Typography variant="h5" color="primary">
          Assinaturas de documentos
        </Typography>
        <SubtitleSignatureHeader variant="body1">
          Aqui você pode acompanhar todas as assinaturas enviadas e finalizadas
          pelos signatários.
        </SubtitleSignatureHeader>
      </Box>
      <Box minWidth={140}>
        <Button
          variant="contained"
          color="primary"
          key="send-envelope-button"
          onClick={onClick}
        >
          Nova assinatura
        </Button>
      </Box>
    </Box>
  );
};

export default SignatureHeader;
